import React from 'react';
import { browserHistory } from 'react-router';

import SiteNav from '../SiteNav';
import ProgressBar from '../ProgressBar';
import BirthdateForm from '../BirthdateForm';

import { useScrollToTop } from '@evdy/web-core/dist/customHooks';
import { useGetWebleadFromCookie, useDetectWebleadUser } from '../../customHooks';

import styles from './BirthdateStep.module.scss';

const { 'birthdate-step': birthdateStepClass, 'step-content': stepContentClass } = styles;

const BirthdateStep = () => {
  // scroll to top on mount
  useScrollToTop();

  // on mount, if no cookie detected navigate back to all packages
  useDetectWebleadUser();

  // on mount, check if weblead cookie exists and fetch existing weblead
  useGetWebleadFromCookie();

  return (
    <div className={birthdateStepClass}>
      <SiteNav />
      <div className={stepContentClass}>
        <ProgressBar step={2} steps={4} />
        <BirthdateForm moveToNextStep={() => browserHistory.push('/b/city')} />
      </div>
    </div>
  );
};

export default BirthdateStep;
